import React, { Component } from "react";
import { FilePond, registerPlugin } from "react-filepond";

import "filepond/dist/filepond.min.css";

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

class FileUploader extends Component {

    constructor(props) {
        super(props);
        this.getFiles = this.getFiles.bind(this);
    }

    getFiles() {
        try {
            return this.state.files
        }
        catch{ return null; }
    }

    clearFiles() {
        this.refs.filePond.removeFiles();
    }

    render() {
        return (
            <FilePond
                ref={"filePond"}
                labelIdle={`Selecione seus arquivos <span class="filepond--label-action">aqui!</span>`}
                files={this.files}
                allowMultiple={true}
                onupdatefiles={(fileItems) => {
                    if (fileItems.length === 0) {
                    }
                    this.setState({ files: fileItems.map((fileItem) => fileItem.file) });
                }}
                data-max-file-size="100MB" />
        );
    }
}

export default FileUploader;
